import { userFragment } from '@eluve/frontend-feature-location-hierarchy';
import { graphql } from '@eluve/graphql.tada';

export const siteBannerStatusFragment = graphql(`
  fragment SiteBannerStatus on SiteBanners @_unmask {
    __typename
    id
    isActive
  }
`);

export const siteBannerPublicDataFragment = graphql(
  `
    fragment SiteBannerPublicData on SiteBanners @_unmask {
      ...SiteBannerStatus
      bannerType
      title
      message
      createdAt
    }
  `,
  [siteBannerStatusFragment],
);

export const siteBannerFragment = graphql(
  `
    fragment SiteBanner on SiteBanners @_unmask {
      ...SiteBannerPublicData
      createdBy
      updatedAt
      user {
        ...User
      }
    }
  `,
  [userFragment, siteBannerPublicDataFragment],
);

export const siteBannersFragment = graphql(
  `
    fragment SiteBanners on query_root @_unmask {
      siteBanners {
        ...SiteBanner
      }
    }
  `,
  [siteBannerFragment],
);

export const siteBannersPublicDataFragment = graphql(
  `
    fragment SiteBanners on query_root @_unmask {
      siteBanners(orderBy: { createdAt: DESC }) {
        ...SiteBannerPublicData
      }
    }
  `,
  [siteBannerPublicDataFragment],
);

export const getSiteBannersAdminQuery = graphql(
  `
    query getAdminSiteBanners {
      ...SiteBanners
    }
  `,
  [siteBannersFragment],
);

export const setSiteBannerStatusMutation = graphql(
  `
    mutation setSiteBannerStatus($siteBannerId: uuid!, $isActive: Boolean!) {
      updateSiteBannersByPk(
        pkColumns: { id: $siteBannerId }
        _set: { isActive: $isActive }
      ) {
        __typename
        ...SiteBannerStatus
      }
    }
  `,
  [siteBannerStatusFragment],
);

export const getSiteBannersQuery = graphql(
  `
    query getSiteBanners {
      ...SiteBanners
    }
  `,
  [siteBannersPublicDataFragment],
);
